import {
    instance as axios,
    setJwtToken,
    setMultiPartHeader,
} from "../../config/axiosInstance";
// ---------------------Event-listing--------------------------
export const eventListApi = async (data) => {
    const endPoint =
        `event/list` +
        "?" +
        new URLSearchParams({ ...data }).toString();

    return await axios.get(endPoint, setJwtToken());
};
// ------------------------Add Event------------------
export const addEventApi = async (data) => {
    const endPoint = `event/add`;
    return await axios.post(endPoint, data, setMultiPartHeader());
};
// ------------------------Edit Event------------------
export const editEventApi = async (data) => {
    const endPoint = `event/update`;
    return await axios.put(endPoint, data, setMultiPartHeader());
};
export const updateEventStatus = async (data) => {
    const endPoint = `event/status`;
    return await axios.put(endPoint, data, setJwtToken());
};
// ------------------------- remove Status------------
export const removeEventApi = async (id) => {
    const endPoint = `event/delete/${id}`;
    return await axios.delete(endPoint, setJwtToken());
};
// ------------------------- event detail------------
export const eventDetailApi = async (id) => {
    const endPoint = `event/detail/${id}`;
    return await axios.get(endPoint, setJwtToken());
};
